'use strict';

exports.__esModule = true;
exports['default'] = {
  optional: ' (optional)',
  required: '',
  add: 'Add',
  remove: 'Remove',
  up: 'Up',
  down: 'Down'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/tcomb-form/lib/i18n/en.js
// module id = 2137
// module chunks = 69